// extracted by mini-css-extract-plugin
export var animateCircle = "one-service-faq-module--animate-circle--iwtEX";
export var bounce = "one-service-faq-module--bounce--UuYVT";
export var contentItemDescription = "one-service-faq-module--contentItemDescription--KWmLU";
export var faqItem = "one-service-faq-module--faqItem--YUxWG";
export var ldsRing = "one-service-faq-module--lds-ring--moqDe";